<template>
	<div>
		<h3>已结算账单</h3>
		<div class="searchBox">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="时间范围">
					<el-date-picker
					  v-model="formInline.time"
					  type="date"
					  placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
<!-- 				<el-form-item label="关键字">
					<el-input v-model="formInline.user" placeholder="关键字"></el-input>
				</el-form-item> -->
				<el-button class="text2 " type="primary" @click='getData'>查询</el-button>
			</el-form>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height='calc(100vh - 300px)'>
				<el-table-column prop="bill.id" label="ID" width="50"></el-table-column>
				<el-table-column label="出单时间" width='170'>
					<template slot-scope="scope">{{ setTime(scope.row.bill.createAt) }}</template>
				</el-table-column>
				<el-table-column prop="product.name" label="商品"></el-table-column>
				<el-table-column label="类型" align="center" width="100">
					<template slot-scope="scope">
						{{typeRstatus[scope.row.cut.rtype - 1]}}
					</template>
				</el-table-column>
				<el-table-column label="数量" align='center' width="100">
					<template slot-scope="scope">
						<span class="yellow"> {{scope.row.cut.billDetailCount}} 个</span>
					</template>
				</el-table-column>
				<el-table-column label="收入类型" width="100">
					<template slot-scope="scope">
						<span :class="scope.row.cut.type == 1?'green':'red'">{{scope.row.cut.type == 1 ?'收入 ':'支出 '}}</span>
					</template>
				</el-table-column>
				<el-table-column label="流水金额" width="100">
					<template slot-scope="scope">
						<span :class="scope.row.cut.type == 1?'green':'red'">{{scope.row.cut.amount/100}} 元 </span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="channel.name" label="渠道"></el-table-column> -->
				<el-table-column label="付款金额" width="100">
					<template slot-scope="scope">
						<span class="yellow">￥{{scope.row.bill.saleAmount/100}}元</span>
					</template>
				</el-table-column>
				<el-table-column label="订单状态" width="120">
					<template slot-scope="scope">
						<span class="yellow">{{billingState[scope.row.bill.billingState]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" width="100" align="center">
					<template slot-scope="scope">
						<router-link class="blue" :to="{path:'/financial/yesSettlement/financialDetails',query:{id:scope.row.bill.id}}">查看详情</router-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
	import { listByState } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				formInline: {
					user: '',
					time: ''
				},
				tableData: [],
				tableData4: [],
				billingState:['创建','线上支付完成','挂帐月结-未付','线下转账-已付款','已退单','投保失败退单'],
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页	
				typeRstatus:['订单' , '分成' , '退单-订单' , '退单-分成']
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},			
			setTime(str) {
				return common.time(str)
			},
			getData(){
				var day='';
				if(this.formInline.time != ''){
					day=common.time1(this.formInline.time)
				}
				var data={
					state:1,
					start:this.indexPage,
					count:this.eachPage,
					day
				}
				listByState(data)
				.then(res => {
					console.log(res)
					this.tableData=res.data.obj;
					this.allpage=res.data.total;
					// this.handleSizeChange(this.eachPage);
				})
				.catch(err => {
					console.log(err)
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>
<style>
	.el-range-separator {
		width: 20px !important;
	}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}
	.text{line-height: 32px;}
	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}
	.fenye .button{float: left;}
	.fenye .pagination {
		float: right;
	}
</style>



// WEBPACK FOOTER //
// src/views/financial/yesSettlement.vue